import { foodTypes } from "./foodTypes";

export const biryaniIncrease = () => {
    return {
        type : foodTypes.BIRYANI_INCREASE,
        payload : 250
    }
}
export const biryaniDecrease = () => {
    return {
        type : foodTypes.BIRYANI_DECREASE,
        payload : 250
    }
}
export const friedRiceIncrease = () => {
    return {
        type : foodTypes.FRIED_RICE_INCREASE,
        payload : 85
    }
}
export const friedRiceDecrease = () => {
    return {
        type : foodTypes.FRIED_RICE_DECREASE,
        payload : 85
    }
}
export const vegBiryaniIncrease = () => {
    return {
        type : foodTypes.VEG_BIRYANI_INCREASE,
        payload : 125
    }
}
export const vegBiryaniDecrease = () => {
    return {
        type : foodTypes.VEG_BIRYANI_DECREASE,
        payload : 125
    }
}
export const southMealsIncrease = () => {
    return {
        type : foodTypes.SOUTH_MEALS_INCREASE,
        payload : 100
    }
}
export const southMealsDecrease = () => {
    return {
        type : foodTypes.SOUTH_MEALS_DECREASE,
        payload : 100
    }
}
export const northMealsIncrease = () => {
    return {
        type : foodTypes.NORTH_MEALS_INCREASE,
        payload : 150
    }
}
export const northMealsDecrease = () => {
    return {
        type : foodTypes.NORTH_MEALS_DECREASE,
        payload : 150
    }
}
export const tandooriChickenIncrease = () => {
    return {
        type : foodTypes.TANDOORI_CHICKEN_INCREASE,
        payload : 300
    }
}
export const tandooriChickenDecrease = () => {
    return {
        type : foodTypes.TANDOORI_CHICKEN_DECREASE,
        payload : 300
    }
}
export const grillChickenIncrease = () => {
    return {
        type : foodTypes.GRILL_CHICKEN_INCREASE,
        payload : 300
    }
}
export const grillChickenDecrease = () => {
    return {
        type : foodTypes.GRILL_CHICKEN_DECREASE,
        payload : 300
    }
}
export const clearAllFood = () => {
    return { type : foodTypes.CLEAR_ALL_FOOD }
}
